export default __webpack_public_path__ + "media/cfc133ca2662fd02840e3196690a2bdcef33e64edae5029c845cba8f1cead69b.svg";